import { connectToStores } from 'fluxible-addons-react';
import { QUANTUM_UI } from '../../../../../flags';
import DocumentStore from '../../../../stores/DocumentStore';
import { SearchResult } from './SearchResult';
import { SearchResult as SearchResultOld } from './SearchResult.old';
var SearchResultComponent = QUANTUM_UI ? SearchResult : SearchResultOld;
export default connectToStores(SearchResultComponent, [DocumentStore], function (context, _a) {
    var url = _a.url;
    var doc = context.getStore(DocumentStore).getDocument(url);
    if (doc && doc.meta) {
        return {
            crumbs: doc.meta.breadcrumbs,
            description: doc.meta.description,
            url: doc.meta.url,
            isDocument: true,
        };
    }
    return {
        isDocument: false,
    };
});
